import { render, staticRenderFns } from "./addresModel.vue?vue&type=template&id=1cb03df6&scoped=true&"
import script from "./addresModel.vue?vue&type=script&lang=js&"
export * from "./addresModel.vue?vue&type=script&lang=js&"
import style0 from "./addresModel.vue?vue&type=style&index=0&id=1cb03df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb03df6",
  null
  
)

export default component.exports